import { defineMessages } from 'react-intl';

const messages = defineMessages({
  home: {
    id: 'clubskpLoggedInSalon.home',
    defaultMessage: 'Home',
    description: 'clubskpLoggedInSalon.home',
  },
  rewards: {
    id: 'clubskpLoggedInSalon.rewards',
    defaultMessage: 'Clubskp',
    description: 'clubskpLoggedInSalon.rewards',
  },
  index: {
    id: 'clubskpLoggedInSalon.index',
    defaultMessage: 'Dashboard',
    description: 'clubskpLoggedInSalon.index',
  },
  points: {
    id: 'clubskpLoggedInSalon.points',
    defaultMessage: 'Points Earned',
    description: 'clubskpLoggedInSalon.points',
  },
  orders: {
    id: 'clubskpLoggedInSalon.orders',
    defaultMessage: 'Orders',
    description: 'clubskpLoggedInSalon.orders',
  },
  activities: {
    id: 'clubskpLoggedInSalon.activities',
    defaultMessage: 'Activities',
    description: 'clubskpLoggedInSalon.activities',
  },
  content: {
    id: 'clubskpLoggedInSalon.content',
    defaultMessage: "Member's Lounge",
    description: 'clubskpLoggedInSalon.content',
  },
  news: {
    id: 'clubskpLoggedInSalon.news',
    defaultMessage: 'News',
    description: 'clubskpLoggedInSalon.news',
  },
  education: {
    id: 'clubskpLoggedInSalon.education',
    defaultMessage: 'Education',
    description: 'clubskpLoggedInSalon.education',
  },
  products: {
    id: 'clubskpLoggedInSalon.products',
    defaultMessage: 'Products',
    description: 'clubskpLoggedInSalon.products',
  },
});

export default {
  to: ['home'],
  logoSrc: '/assets/img/black/logo.svg',
  title: [
    { text: 'CLUB', color: '#ec2027' },
    { text: 'SKP', color: '' },
  ],
  links(group, siteId, intl) {
    return [
      {
        iconClass: 'left-nav-icons left-nav-icons--home',
        title: intl.formatMessage(messages.home),
        to: ['home'],
        links: false,
      },
      // {
      //   iconClass: 'left-nav-icons left-nav-icons--rewards',
      //   title: intl.formatMessage(messages.rewards),
      //   target: null,
      //   to: ['rewards'],
      //   links: false,
      // },
      {
        iconClass: 'left-nav-icons left-nav-icons--dashboard',
        title: intl.formatMessage(messages.index),
        to: ['clubskp-index'],
        links: false,
      },
      // {
      //   iconClass: 'left-nav-icons left-nav-icons--expenses',
      //   title: intl.formatMessage(messages.points),
      //   to: ['clubskp-points'],
      //   links: false,
      // },
      // {
      //   iconClass: 'left-nav-icons left-nav-icons--products',
      //   title: intl.formatMessage(messages.orders),
      //   to: ['clubskp-orders'],
      //   links: false,
      // },
      // {
      //   iconClass: 'left-nav-icons left-nav-icons--activities',
      //   title: intl.formatMessage(messages.activities),
      //   to: ['clubskp-activities'],
      //   links: false,
      // },
      // {
      //   iconClass: 'left-nav-icons left-nav-icons--user',
      //   title: intl.formatMessage(messages.content),
      //   to: ['clubskp-content'],
      //   links: false,
      // },
      // {
      //   iconClass: 'left-nav-icons left-nav-icons--skp',
      //   title: 'How It Works',
      //   to: ['about'],
      //   links: false,
      // },
      // {
      //   iconClass: 'left-nav-icons left-nav-icons--news',
      //   title: intl.formatMessage(messages.news),
      //   to: ['news'],
      //   links: false,
      // },
      // {
      //   iconClass: 'left-nav-icons left-nav-icons--education',
      //   title: intl.formatMessage(messages.education),
      //   to: ['education'],
      //   links: false,
      // },
      {
        iconClass: 'left-nav-icons left-nav-icons--products',
        title: intl.formatMessage(messages.products),
        to:
          siteId === 'ca'
            ? 'http://www.schwarzkopf-professional.ca/skp/ca/en/home/products/brands.html'
            : 'http://www.schwarzkopf-professionalusa.com/skp/us/en/home/products/brands.html',
        links: false,
      },
      // {
      //   iconClass: 'left-nav-icons left-nav-icons--promotions',
      //   title: 'Promotions',
      //   to: ['page', { slug: 'promotions' }],
      //   links: false,
      // },
    ];
  },
};



// WEBPACK FOOTER //
// ./src/configs/sidebar/clubskpLoggedInSalon.js